import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

import { DateStrings } from '@app/eds';

@Pipe({
  name: 'dateFormat'
})
export class DateFormatPipe extends DatePipe implements PipeTransform {
  /**
   * Transforms date-time to dd/MM/yyyy format
   */
  override transform(value: any, args?: any): any {
    return super.transform(value, DateStrings.DD_MM_YYYY_FORMAT);
  }

  /**
   * Transforms date-time to dd/MM/yyyy format
   */
  transformDate(value: any, args?: any): any {
    return super.transform(value, DateStrings.YYYY_MM_DD_FORMAT);
  }
}
